function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { Flex } from "../..";
import { Icon } from "../../icon";
export var ValueContainer = function ValueContainer(_ref) {
  var hasValue = _ref.hasValue,
      selectProps = _ref.selectProps,
      innerProps = _ref.innerProps,
      children = _ref.children;
  var theme = selectProps.theme,
      isSearchable = selectProps.isSearchable,
      showPlaceholderIcon = selectProps.showPlaceholderIcon,
      placeholderIcon = selectProps.placeholderIcon,
      variant = selectProps.variant;
  var hasPadding = variant === 'inline';
  return /*#__PURE__*/React.createElement(Flex, _extends({}, innerProps, {
    className: selectProps.classes.valueContainer,
    pt: hasPadding ? '20px' : '0px',
    pb: hasPadding ? '6px' : '0px'
  }), isSearchable && showPlaceholderIcon && !hasValue ? /*#__PURE__*/React.createElement(Icon, {
    icon: placeholderIcon,
    theme: theme,
    className: theme.inputPlaceholderIcon
  }) : null, children);
};